import React from 'react';

import s from './styles.module.scss';

interface IProps {
  title: string;
  subTitle: string;
}

const ConsentFormHeader: React.FC<IProps> = ({ title, subTitle }) => (
  <div className={s.header}>
    <img src="/accuhealth.png" alt="accuhealth" />
    <h3 className={s.title}>{title}</h3>
    <h3 className={s.title}>{subTitle}</h3>
  </div>
);

export default ConsentFormHeader;
